<template>
	<link-input class="link-object-input"
				:suffix-icon="suffixIcon"
				input-readonly
				:value="(!!row&&!!showKey)?row[showKey]:null"

				:type="type"
				:color="color"
				:size="size"
				:shape="shape"
				:dashed="dashed"
				:long="long"
				:prefixIcon="prefixIcon"
				:placeholder="placeholder"
				:disabled="lv_disabled"
				:width="width"
				:clear-on-click-delete-icon="false"
				:hide-clear-icon="hideClearIcon"
				:required="required"
				:validate-on-init="validateOnInit"
				:rules="rules"
				@click-suffix-icon="!lv_disabled&&!lv_readonly && handleClickSuffixIcon()"
				@click="!lv_disabled&&!lv_readonly  && handleClick()"/>
</template>

<script>
	import {AutoOption} from "../auto-table/link-auto-option";
	import LinkInput from "../input/link-input";
	import {EditMixin} from "../mixins";

	export default {
		name: "link-object-input",
		components: {LinkInput},
		mixins: [EditMixin],
		props: {
			option: {required: true, type: AutoOption},

			row: {required: true, type: Object},
			map: {require: true, type: Object},
			showKey: {required: true, type: String},

			onConfirm: {type: Function},
			onCancel: {type: Function},
			onComplete: {type: Function},
			beforeSelect: {type: Function},
			afterSelect: {type: Function},

			type: {type: String, default: 'line',},
			color: {type: String, default: 'info',},
			size: {type: String, default: 'default',},
			shape: {type: String, default: 'none',},
			dashed: {type: Boolean,},
			long: {type: Boolean,},
			prefixIcon: {type: String},
			suffixIcon: {type: String, default: 'link-icon-search'},
			placeholder: {type: String, default: () => LinkVue.$t('LinkAutoTable.search')},
			regexp: {type: RegExp},
			width: {},
			hideClearIcon: {type: Boolean},
			required: {type: Boolean},
			rules: {type: Array | String},
			validateOnInit: {type: Boolean,},
		},
		methods: {
			async handleClick() {
				!!this.beforeSelect && (await this.beforeSelect({row: this.row, option: this.option}))
				this.$object.pick({
					option: this.option,
					onConfirm: this.onConfirm || this.handleConfirm,
					onCancel: this.onCancel || this.handleCancel,
					onComplete: this.onComplete || this.handleComplete,
				})
			},
			async handleConfirm(data) {
				this.$emit('confirm', data)
				!!this.map && Object.keys(this.map).forEach(key => this.$set(this.row, key, data[this.map[key]]));
				!!this.afterSelect && (await this.afterSelect({row: this.row, option: this.option, selectRow: data}))
				this.$emit('change', data)
			},
			handleCancel() {
				this.$emit('cancel')
			},
			handleComplete() {
				this.$emit('complete')
			},
			async handleClickSuffixIcon() {
				!!this.beforeSelect && (await this.beforeSelect({row: this.row, option: this.option}))
				this.$emit('confirm', null)
				Object.keys(this.map).forEach(key => this.$set(this.row, key, null))
				!!this.afterSelect && (await this.afterSelect({row: this.row, option: this.option}))
			},
		}
	}
</script>

<style>
	.link-object-input {
		cursor: pointer;
		box-sizing: border-box;
	}
</style>
